import { OrderCommand } from '../../../../services/command';
import { StoreActionType as Type } from '../../types';

export const getReturnDetails: any = (req: any) => {
    return (dispatch: any) => {
        dispatch({ type: Type.GET_RETURN_DETAILS_REQUEST });

        OrderCommand.GetReturnDetailByOrderId(req)
            .then((res: any) => {
                const payload = Array.isArray(res) ? res : [];
                dispatch({ type: Type.GET_RETURN_DETAILS_SUCCESS, payload });
            })
            .catch((error: any) => {
                console.error('Hata:', error);
                dispatch({ type: Type.GET_RETURN_DETAILS_FAILURE, payload: error });
            });
    };
};
